import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './Card';
import { cn } from '../../lib/utils';

interface ChartCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  headerAction?: React.ReactNode;
  compact?: boolean;
}

export function ChartCard({
  title,
  description,
  children,
  className,
  headerAction,
  compact = false
}: ChartCardProps) {
  return (
    <Card className={cn("h-full", className)}>
      <CardHeader compact={compact}>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle size={compact ? 'sm' : 'default'}>{title}</CardTitle>
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {headerAction && <div className="ml-4">{headerAction}</div>}
        </div>
      </CardHeader>
      <CardContent compact={compact}>
        <div className="w-full h-full">
          {children}
        </div>
      </CardContent>
    </Card>
  );
}
